<template>
    <div class="dev-domains">
        <div v-for="(item, index) in domainsList" type="info" :key="index" size="mini">{{item}}</div>
    </div>
</template>

<script>
export default {
  props: {
    list: {
      type: String,
      default: ''
    },
  },

  data() {
    return {
      domainsList: [],
    };
  },
  created() {
    this.domainsList = this.list.split(';');
  },

  watch: {
    list() {
      this.domainsList = this.list.split(';');
    }
  }
};

</script>

<style lang="scss" scoped>
.dev-domains {
    display: flex;
    flex-direction: column;
}
</style>